module.exports = __webpack_public_path__ + "img/artist.77517ded.png";